<template>
  <div class="">
    <topBar class="pageSonTop" />
    <div class="pageBanner" :style="{backgroundImage:'url('+pb+')'}">
      <div class="kw1400">
        <div class="pageNav">
          <div class="pageNavRow">

            <router-link :to="'/article/'+item.id" v-for="(item,index) in categoryNav">{{item.name}}</router-link>
          </div>
        </div>
      </div>
    </div>


    <!-- <div class="kw1400">
      <img src="@/assets/img/p32.jpg" />
    </div> -->

    <div class=" phoneShow">
      <div v-if="categoryData.content_h5" v-html="categoryData.content_h5"></div>
      <div v-else v-html="categoryData.content_pc"></div>
    </div>
    <div class="pcShow" v-html="categoryData.content_pc"></div>


    <div class="tabNav" v-if="threeNav[0]">
      <div class="kw1400">
        <div class="tabNavRow">
          <!-- <a href="javascript:;" class="active">智慧病房</a> -->
          <a href="javascript:;" v-for="(item,index) in threeNav" @click="threeClick(item.id,index)" :class="{'active':item.check}">{{item.name}}</a>
        </div>
      </div>
    </div>
    <div style="background: #F5F5F5;" class="articleSonMain">

      <div class=" phoneShow">
        <div v-if="threeData.content_h5" v-html="threeData.content_h5"></div>
        <div v-else v-html="threeData.content_pc"></div>
      </div>
      <div class="pcShow" v-html="threeData.content_pc"></div>

    </div>

    <footerBar />
    <loading v-if="isLoading" />

  </div>
</template>

<script>
import {WOW} from '@/assets/js/wow.js'
import footerBar from '@/components/footerBar.vue'
import topBar from '@/components/topBar.vue'
import loading from '@/components/loading.vue'
import { categoryView,categoryLists } from '@/api/web'
export default {
  components:{
    topBar,
    footerBar,
    loading
  },
  watch: {
      // 监听路由参数的变化
    '$route.params.id': {
      immediate: true,
      handler(newVal, oldVal) {
        this.getData()
      }
    }
  },
  data () {
    return {
      businessSwiper:'',
      pb: require('@/assets/img/pb1.jpg'),
      categoryId:'',
      categoryData:{},
      categoryNav:[],
      isLoading:false,
      threeNav:[],
      threeNavCut:{},
      threeData:{}

    }
  },
  mounted() {

      new WOW().init()
      // this.getData()
  },

  methods:{
    threeClick(id,index){
      for(var i = 0; i < this.threeNav.length; i ++){
        if(i == index){
          this.threeNav[i].check = true
          this.threeNavCut = this.threeNav[i]
          this.getThreeData()
        }else{
          this.threeNav[i].check = false
        }
      }

    },
    getThreeData(){
      this.isLoading = true
      categoryView({category_id:this.threeNavCut.id}).then(res => {
        this.isLoading = false
        this.threeData = res.data
      })
    },
    getData(){
      this.categoryId = this.$route.params.id
      this.isLoading = true
      categoryView({category_id:this.categoryId}).then(res => {
            this.isLoading = false
            this.categoryData = res.data

            // 云选项卡
            if(this.categoryId == 29){
              this.$nextTick(() => {
                setTimeout(function() {
                          var containerPc = document.getElementsByClassName('cloudTabNavPc');
                          var btnslistPc = containerPc[0].getElementsByTagName('li');
                          var countent_boxPc = document.getElementsByClassName("cloudTabMainPc");
                          var aLi1Pc = countent_boxPc[0].getElementsByClassName("cloudTabMainRowPc");
                          for(var i = 0; i < btnslistPc.length; i++) {
                            btnslistPc[i].index = i;

                            btnslistPc[i].onclick = function() {

                              for(var j = 0; j < btnslistPc.length; j++) {
                                btnslistPc[j].className = '';
                                this.className = 'active';
                                aLi1Pc[j].style.display = 'none';
                              }
                              aLi1Pc[this.index].style.display = "flex"
                            }
                          }
                          // -----

                          var containerPhone = document.getElementsByClassName('cloudTabNavPhone');
                          var btnslistPhone = containerPhone[0].getElementsByTagName('li');
                          var countent_boxPhone = document.getElementsByClassName("cloudTabMainPhone");
                          var aLi1Phone = countent_boxPhone[0].getElementsByClassName("cloudTabMainRowPhone");
                          for(var i = 0; i < btnslistPhone.length; i++) {
                            btnslistPhone[i].index = i;

                            btnslistPhone[i].onclick = function() {

                              for(var j = 0; j < btnslistPhone.length; j++) {
                                btnslistPhone[j].className = '';
                                this.className = 'active';
                                aLi1Phone[j].style.display = 'none';
                              }
                              aLi1Phone[this.index].style.display = "flex"
                            }
                          }
                  }, 200);
                })
              }
              // ------------------end



            this.threeData = {}
            categoryLists({pid:this.categoryData.pid}).then(res => {
              this.categoryNav = res.data

              for(var i = 0 ; i < this.categoryNav.length; i++){
                if(this.categoryNav[i].id == this.categoryId){
                  this.threeNav = this.categoryNav[i].childs

                  for(var j = 0; j < this.threeNav.length; j++){
                    if(j == 0){
                      this.threeNavCut = this.threeNav[j]
                      this.threeNav[j].check = true
                    }else{
                      this.threeNav[j].check = false
                    }
                  }

                  if(this.threeNav[0]){
                    this.getThreeData()
                  }
                }
              }
            })




            var webTitle
            if(this.categoryData.parent){
              webTitle = ' > '+ this.categoryData.parent.name + ' > ' +this.categoryData.name
            }else{
              webTitle = ' > ' +this.categoryData.name
            }
            this.tools.setWebTitle(webTitle)
      })
    }
  }
}
</script>
<style>
.pcShow p:first-child,
.phoneShow p:first-child{
  margin-top: 0;
}
.articleSonMain p{
  margin: 0;
  padding: 0;
}
.articleSonMain img{
  display: block;
}
</style>





// WEBPACK FOOTER //
// src/view/article/index.vue